const _ = require('lodash');

module.exports = function (StorePickerService) {
    return {
        restrict: 'E',
        scope: {
            isSearchEnabled: '='
        },
        link(scope) {
            scope.isDelivery = true;
            scope.storePicker = StorePickerService;

            scope.storeSelected = _.debounce((store) => {
                if (store.PostCode) {
                    scope.selectedStore = store;
                }
            }, 500);

        },
        template: require('./store-picker-delivery-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/storepicker/store-picker-delivery-directive.js
 **/